import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { MazFeedbackPayload } from '../models/maz-feedback';
import { MazMessage } from '../models/maz-message';
import { MazResponse } from '../models/maz-response';

export const MazActions = createActionGroup({
  source: 'Maz',
  events: {
    Init: emptyProps(),
    'Get Conversation History Success': props<{ mazMessages: MazMessage[] }>(),
    'Toggle Maz Chat': emptyProps(),
    'Send Message To Maz': props<{ userInput: string }>(),
    'Waiting For Maz Reply': emptyProps(),
    'Receive Message From Maz': props<{ response: MazResponse }>(),
    'Failed To Receive Message From Maz': props<{ error: unknown; message: string }>(),

    'Send Message Feedback': props<{ feedback: MazFeedbackPayload }>(),

    /** User can opt in/out of Maz chat */
    'Toggle User Maz Status': props<{ enabled: boolean }>(),
  },
});
